import * as yup from 'yup'

// TODO: 共通化
const strictEmailRegex =
  /^(?=[a-zA-Z0-9._%+=]{1,64}@)(?=[a-zA-Z0-9.-]{1,255})[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/

export const loginFormSchema = yup.object().shape({
  email: yup
    .string()
    .required('必須項目です。')
    .matches(strictEmailRegex, '無効なメールアドレスです'),
  password: yup.string().required('必須項目です。').min(6, 'パスワードは６'),
})

export const changePasswordFormSchema = yup.object().shape({
  newPassword: yup
    .string()
    .min(6, '最低6文字以上で入力してください。')
    .required('必須項目です。'),
  confirmNewPassword: yup
    .string()
    .oneOf([yup.ref('newPassword')], 'パスワードが一致しません')
    .required('必須項目です。'),
})

export const selectGroupFormSchema = yup.object().shape({
  group: yup.number().required('必須項目です。'),
})
